import { redactSensitive, redactUrl, boundRedactedBody } from './redact';
const errors = [];
function scrubSupportSecrets(text) {
  // Quoted JSON values can contain spaces; cookie headers can contain many
  // semicolon-separated credentials. Scrub the entire value before token passes.
  // Bearer uses the same non-space class as the server so %20 stays inside the token.
  const marked = text.replace(/\b(?:cookie|set-cookie)\b["']?\s*[:=]\s*[^\r\n]*/gi, '[REDACTED]').replace(/\b(?:token(?:_hash)?|code|access_token|refresh_token|api[_-]?key|password|authorization|secret|session)\b["']?\s*[:=]\s*(?:"[^"]*"|'[^']*')/gi, '[REDACTED]').replace(/\bBearer\s+[^\s"'<>]+/gi, '[REDACTED]');
  return String(boundRedactedBody(redactSensitive(marked), 100000)).replace(/\b(?:sk_|pk_|rk_|sb_secret_|sb_publishable_)[\w-]+/g, '[REDACTED]').replace(/\bcode(["']?\s*[:=]\s*["']?)[^\s"'&,;}<>]+/gi, '$1[REDACTED]').replace(/\b(?:\d[ -]?){13,19}\b/g, '[REDACTED]').replace(/\[redacted\]/gi, '[REDACTED]');
}
export function scrubSupport(value, max = 5000) {
  // Same order as the server scrub: raw values first, then decode, then again.
  // Decoding %20 before the match splits password=my%20secret and leaks the tail.
  let text = scrubSupportSecrets(String(value ?? ''));
  for (let pass = 0; pass < 2; pass++) text = text.replace(/(?:%[0-9a-f]{2})+/gi, part => { try { return decodeURIComponent(part); } catch { return part; } });
  return scrubSupportSecrets(text).slice(0, max);
}
export function recordSupportError(message, context = {}) {
  errors.push({
    time: new Date().toISOString(),
    message: scrubSupport(message, 500),
    stack: new TextDecoder().decode(new TextEncoder().encode(scrubSupport(context.stack || context.error,2048)).subarray(0,2048)).replace(/\uFFFD$/, ''),
    route: scrubSupport(redactUrl(context.route || globalThis.location?.pathname || ''), 1000),
    sentry_id: scrubSupport(context.sentry_id, 100)
  });
  while (errors.length > 20) errors.shift();
}
export function getSupportErrors(now = Date.now()) {
  return errors.filter(e => now - Date.parse(e.time) <= 1800000).map(e => ({
    ...e
  }));
}
export function captureSupportContext() {
  return {
    route: scrubSupport(redactUrl(location.pathname + location.search), 1000),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    app_version: import.meta.env.VITE_APP_VERSION || import.meta.env.VITE_COMMIT_REF || 'unknown',
    ua: scrubSupport(navigator.userAgent, 500),
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    client_errors: getSupportErrors()
  };
}
export function supportValidation(draft) {
  return {
    ...(!['broken', 'question', 'billing', 'other'].includes(draft.category) ? {
      category: 'Choose a category'
    } : {}),
    ...(draft.subject.trim().length < 5 || draft.subject.trim().length > 120 ? {
      subject: 'Use 5–120 characters'
    } : {}),
    ...(draft.description.trim().length < 20 || draft.description.trim().length > 5000 ? {
      description: 'Use 20–5000 characters'
    } : {})
  };
}
export function rateLimitCopy(body) {
  if (body.limit === 'daily') return "You've reached today's limit of 20 requests. Try again tomorrow.";
  const n = Math.max(1, Math.ceil(body.retry_minutes || 1));
  const count = n < 60 ? n : Math.ceil(n / 60);
  return `You've sent several requests recently. Try again in ${count} ${n < 60 ? count === 1 ? 'minute' : 'minutes' : count === 1 ? 'hour' : 'hours'}.`;
}
